import {rootApiUrl} from '../../../../../service/api/api-const';

export function getDownloadFileWithErrorsUrl(groupId: number): string {
    return `${rootApiUrl}/cp/prices/source_file/${groupId}/errors/`;
}
